import { markFor, indexOf } from "./marks.js";

const SUIT_LABEL = { action: "ACTION", observation: "OBSERVATION", relation: "RELATION" };
const SUIT_COLOR_VAR = {
  action: "--c-suit-action",
  observation: "--c-suit-observation",
  relation: "--c-suit-relation",
};

function pad2(n) { return String(n).padStart(2, "0"); }

function escapeHtml(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function svgForMark(suit, name, size) {
  const m = markFor(suit, name);
  const inner = m.paths
    .map((p) => {
      if (p.kind === "dot") {
        return `<path d="${p.d}" fill="currentColor" stroke="none"/>`;
      }
      if (p.kind === "dashed") {
        return `<path d="${p.d}" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="2 3"/>`;
      }
      return `<path d="${p.d}" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>`;
    })
    .join("");
  return `<svg viewBox="0 0 96 96" width="${size}" height="${size}" aria-hidden="true">${inner}</svg>`;
}

export function renderCardFace(card) {
  const el = document.createElement("article");
  el.className = `tc-card tc-card-face ${card.suit}`;
  el.dataset.suit = card.suit;
  el.style.setProperty("--axis-color", `var(${SUIT_COLOR_VAR[card.suit]})`);
  const idx = indexOf(card.suit, card.n);
  el.innerHTML = `
    <header class="tc-eyebrow">
      <span class="tc-eyebrow-suit">${SUIT_LABEL[card.suit]}</span>
      <span class="tc-eyebrow-index">${pad2(idx)}/24</span>
    </header>
    <div class="tc-mark-area">${svgForMark(card.suit, card.n, 96)}</div>
    <hr class="tc-divider" />
    <h3 class="tc-name">${escapeHtml(card.n)}</h3>
    <p class="tc-desc">${escapeHtml(card.d)}</p>
    <div class="tc-substrate-tick"></div>
    <p class="tc-substrate">${escapeHtml(card.s).toUpperCase()}</p>
  `;
  return el;
}

export function renderMiniCard(card) {
  const el = document.createElement("article");
  el.className = `tc-mini ${card.suit}`;
  el.dataset.suit = card.suit;
  el.style.setProperty("--axis-color", `var(${SUIT_COLOR_VAR[card.suit]})`);
  const idx = indexOf(card.suit, card.n);
  el.innerHTML = `
    <div class="tc-mini-mark">${svgForMark(card.suit, card.n, 40)}</div>
    <div class="tc-mini-body">
      <div class="tc-mini-name">${escapeHtml(card.n)}</div>
      <div class="tc-mini-eyebrow">${SUIT_LABEL[card.suit]} ${pad2(idx)}/24</div>
    </div>
  `;
  return el;
}

export function renderCanvasCard(card) {
  const el = document.createElement("article");
  el.className = `cv-card tc-card ${card.suit}`;
  el.dataset.suit = card.suit;
  el.style.setProperty("--axis-color", `var(${SUIT_COLOR_VAR[card.suit]})`);
  el.innerHTML = `
    <div class="cv-mark">${svgForMark(card.suit, card.n, 36)}</div>
    <div class="cv-name">${escapeHtml(card.n)}</div>
    <div class="cv-desc">${escapeHtml(card.d)}</div>
  `;
  return el;
}

export function renderTrayCard(card) {
  const el = document.createElement("article");
  el.className = `tray-card tc-card ${card.suit}`;
  el.dataset.suit = card.suit;
  el.style.setProperty("--axis-color", `var(${SUIT_COLOR_VAR[card.suit]})`);
  el.innerHTML = `
    <div class="tray-mark">${svgForMark(card.suit, card.n, 28)}</div>
    <div class="tray-name">${escapeHtml(card.n)}</div>
  `;
  return el;
}
